<template>
  <span
    class="badge"
    :class="[bgClass, textClass]"
  >
    <slot/>
  </span>
</template>

<script>
import {
  COLOR_CALM,
  COLOR_DANGER,
  COLOR_GRAY_600,
  COLOR_INFO,
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  COLOR_WARNING,
} from '../../config/constants';
import { BADGE_TYPES } from './config';

export default {
  name: 'DpBadge',

  props: {
    /**
     * @values primary, success, info, warning, danger, calm, gray-200, gray-600,
     * @default gray-600
     * */
    type: {
      type: String,
      required: false,
      default: COLOR_GRAY_600,
      validator: (value) => BADGE_TYPES.includes(value),
    },
  },

  computed: {
    bgClass() {
      const { type } = this;
      const lightBgBadges = [COLOR_CALM, COLOR_DANGER, COLOR_INFO, COLOR_SUCCESS, COLOR_WARNING];

      if (lightBgBadges.includes(type)) {
        return `bg-${type}-light`;
      }

      return `bg-${type}`;
    },

    textClass() {
      const whiteTextBadges = [COLOR_PRIMARY, COLOR_GRAY_600];

      if (whiteTextBadges.includes(this.type)) {
        return `text-white`;
      }

      return null;
    },
  },
};
</script>
